export const getFileExtension = (fileName: string): string => {
  const parts = fileName.split('.');
  return parts.length > 1 ? `.${parts.pop()?.toLowerCase()}` : '';
};
